import type { GetStaticPaths, GetStaticProps, GetServerSideProps } from "next";
import { ApiService } from "services/server";
import Tab from "views/Tab/Tab";
import {
  normalizeResearchContents,
  normalizeResearchContentsWithDetails,
} from "utils/normalizer";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";
import { checkEmpty } from "utils/newFunction";

function GraduatesPage({ data }) {
  const router = useRouter();
  const [tabs, setTabs] = useState(() => data?.tabs || []);

  const [activeTab, breadcrumb] = useMemo(() => {
    const activeTabKey =
      typeof router.query.slug === "string"
        ? router.query.slug
        : router.query.slug?.[1];
    const active = tabs.find((item) => item?.slug === activeTabKey);
    if (active) {
      return [active, data?.breadcrumb?.concat({ title: active.tabName })];
    }
    return [tabs[0], data?.breadcrumb];
  }, [router.query.slug, tabs]);

  useEffect(() => {
    setTabs(data?.tabs || []);
  }, [data?.tabs]);

  const onTabChange = (slug: string) => {
    router.push(`/graduates/${slug}`, undefined, { shallow: true });
  };

  return (
    <Tab
      data={data}
      onTabChange={onTabChange}
      activeTab={activeTab}
      breadcrumb={breadcrumb}
    />
  );
}

// export const getStaticPaths: GetStaticPaths = async () => {
//   return {
//     paths: [],
//     fallback: true,
//   };
// };

// export const getStaticProps: GetStaticProps = async ({ locale }) => {
//   const apiService = new ApiService(locale);
//   const entityId =
//     ENTITY_ID?.[locale?.toUpperCase()]?.[CMS_ENVIRONMENT || "production"]
//       ?.GRADUATEDS_ID;

//   const requests = [
//     apiService.getContentByEntityId(+entityId), // 0
//   ];

//   const response = await ApiService.multipleRequest(requests);

//   if (checkEmpty(...response)) {
//     throw new Error();
//   }

//   const general = response?.[0]?.[0];
//   const tabsResult = normalizeResearchContentsWithDetails(
//     normalizeResearchContents(general?.researchContents)
//   );

//   return {
//     props: {
//       data: {
//         breadcrumb: general?.breadcrumb || [],
//         tabs: tabsResult?.map((item) => ({
//           ...item,
//           changeLanguageLink: item?.changeLanguageLink,
//         })),
//         metaTag: general?.metaTag || {},
//         useDefaultHrefLang: false,
//       },
//     },
//     revalidate: REVALIDATE_TIME,
//   };
// };
export const getServerSideProps: GetServerSideProps = async ({
  params,
  locale,
}) => {
  const apiService = new ApiService(locale);

  try {
    const requests = [
      apiService.getGraduateds(), // 0
    ];
    let response = [];
    try {
      response = await ApiService.multipleRequest(requests);
    } catch (e) {}

    const tabsResult = normalizeResearchContentsWithDetails(
      normalizeResearchContents(response[0]?.[0]?.researchContents),
      locale
    );

    const general = response?.[0]?.[0];

    const destination = `${
      locale === "en" ? "/en" : ""
    }/graduates/${encodeURIComponent(tabsResult?.[0]?.slug)}`;
    const isExist = tabsResult?.find((item) => item?.slug === params?.slug);

    if (!isExist) {
      return {
        redirect: {
          destination: destination,
          permanent: true,
        },
      };
    }

    return {
      props: {
        data: {
          breadcrumb: general?.breadcrumb || [],
          tabs: tabsResult?.map((item) => ({
            ...item,
            changeLanguageLink: item?.changeLanguageLink,
          })),
          metaTag: general?.metaTag || {},
          useDefaultHrefLang: false,
        },
      },
    };
  } catch (err) {
    return {
      redirect: {
        destination: "/500",
        permanent: false,
      },
    };
  }
};

export default GraduatesPage;
